export default __webpack_public_path__ + "static/media/12.712f6860.jpg";